.contentPage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  height: max(50vh, 600px);
  width: max(50vw, 1000px);
  border-radius: 0.5rem;
  overflow: visible; /* Hide both scrollbars */
  background-color: white;
  box-shadow: 
    2px 4px 8px rgba(0, 0, 0, 0.1),
    -2px -1px 16px rgba(0, 0, 0, 0.1);
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible; /* Hide both scrollbars */
}

.slidesContainer {
  display: flex;
  transition: transform 0.5s ease;
  width: 100%;
  height: 100%;
  overflow: hidden; /* Hide both scrollbars */
}

.slide {
  border-radius: 0.5rem;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden; /* Remove vertical scroll from individual slides */
}

.hiddenSlide {
  display: none;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 3rem;
  height: 3rem;
  color: white;
  z-index: 10;
  cursor: pointer;
}

.arrowLeft {
  composes: arrow;
  left: -80px;
}

.arrowRight {
  composes: arrow;
  right: -65px;
}

.loading,
.error {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 1.2rem;
  color: #666;
}

.contentIndicators {
  display: flex;
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
}

.contentIndicator {
  background-color: white;
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 100%;
  border: none;
  outline: none;
  box-shadow: 0px 0px 5px #555;
  margin: 0 0.2rem;
  cursor: pointer;
}

.indicatorInactive {
  background-color: grey;
}

.letsGoButton {
  position: absolute;
  right: -80px; /* Move it further to the right */
  top: 50%;
  transform: translateY(-50%);
  padding: 10px 20px;
  font-size: 16px;
  background-color: var(--color-primary);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease;
  z-index: 20;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  overflow: visible;
}

.letsGoButton:hover {
  background-color: var(--color-primary-hover);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

@media screen and (max-width: 768px) {
  .contentPage {
    max-width: 450px;
    margin: 10px auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .arrow {
    width: 2.5rem;
    height: 2.5rem;
  }

  .letsGoButton {
    font-size: 12px;
    padding: 6px 12px;
    top: 47%;
  }
}

@media screen and (max-width: 460px) {
  .contentPage {
    max-width: 420px;
    /* height: 450px; */
    /* margin: 5px auto; */
    margin-left: auto;
    margin-right: auto;
  }

  .arrow {
    width: 1.8rem;
    height: 1.8rem;
  }

  .arrowLeft {
    top: 310px;
    left: -15px;
  }

  .arrowRight {
    right: -15px;
  }

  .letsGoButton {
    right: -30px;
    padding: 5px 10px;
    font-size: 11px;
    border-radius: 6px;
  }
}
